import React from 'react';
import EditarInsumos from '../../../components/insumos/insumos/EditarInsumos';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Editar Insumos</h1>
      <br />
      <br />
      <EditarInsumos />
    </div>
  );
};

export default InsumosPage;